import { render, staticRenderFns } from "./creditNoteList.vue?vue&type=template&id=bd8877a6&"
import script from "./creditNoteList.vue?vue&type=script&lang=js&"
export * from "./creditNoteList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports